import { useNavigate } from 'react-router-dom'
import type { DashboardRefill } from '../../store/dashboardSlice'

interface PendingRefillsProps {
  refills: DashboardRefill[]
}

function formatDate(dateStr: string | null): string {
  if (!dateStr) return '-'
  const d = new Date(dateStr)
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

export function PendingRefills({ refills }: PendingRefillsProps) {
  const navigate = useNavigate()

  return (
    <div data-testid="pending-refills">
      <h2 className="text-[14px] font-medium text-text-primary mb-3">Pending Refills</h2>

      {refills.length === 0 ? (
        <p className="text-[12px] text-text-muted py-4 text-center" data-testid="pending-refills-empty">
          No pending refills
        </p>
      ) : (
        <div className="flex flex-col">
          {/* Header */}
          <div
            className="dash-pr-header grid items-center h-9 text-[11px] font-medium text-text-muted uppercase tracking-wide"
            style={{ gridTemplateColumns: '1fr 1fr 100px 120px' }}
          >
            <span className="px-2">Patient</span>
            <span className="px-2">Medication</span>
            <span className="px-2">Refills Left</span>
            <span className="px-2">Last Filled</span>
          </div>

          {/* Rows */}
          {refills.map((rx) => (
            <div
              key={rx.id}
              data-testid={`pending-refill-row-${rx.id}`}
              onClick={() => navigate(`/prescriptions/${rx.id}`)}
              className="dash-pr-row grid items-center h-[44px] text-[13px] text-text-primary hover:bg-hover transition-colors duration-100 cursor-pointer"
              style={{ gridTemplateColumns: '1fr 1fr 100px 120px' }}
            >
              <span className="px-2 font-[500] truncate" data-testid="refill-patient-name">
                {rx.patient_name}
              </span>
              <span className="px-2 text-[12px] text-text-secondary truncate" data-testid="refill-medication">
                {rx.medication_name}
              </span>
              <span className="px-2 text-[12px] text-text-secondary" data-testid="refill-remaining">
                {rx.remaining_refills}
              </span>
              <span className="px-2 text-[12px] text-text-muted" data-testid="refill-last-filled">
                {formatDate(rx.last_filled_date)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
